<svelte:window on:click="clickHandler(event)" />

<div ref:container>
	<slot></slot>
</div>

<script>
export default {
	methods: {
		clickHandler(event) {
			if (this.refs.container.contains(event.target)) {
				this.fire('clickInternal', event)
			} else {
				this.fire('clickExternal', event)
			}
		}
	}
}
</script>
